import { styled } from '@mui/material/styles';
import { Step, StepConnector, stepConnectorClasses, StepLabel } from '@mui/material';
import { abyssColors, stepperColors } from '@/theme/colors';

export const StyledStepConnector = styled(StepConnector)({
  paddingRight: '1.2em',
  paddingLeft: '1.2rem',
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '1.6rem',
    left: 'calc(-50% + rem)',
    right: 'calc(50% + 2rem)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: abyssColors.success[600],
      transition: 'all 0.3s ease-in-out',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: abyssColors.success[600],
      transition: 'all 0.3s ease-in-out',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: '0.2rem',
    border: 0,
    backgroundColor: stepperColors.border.inactive,
    width: '10.4rem',
    transition: 'all 0.3s ease-in-out',
  },
});

interface StyledStepIconRootProps {
  ownerState: {
    active?: boolean;
    completed?: boolean;
  };
}

export const StyledStepIconRoot = styled('div')<StyledStepIconRootProps>(({ ownerState }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '3.2rem',
  height: '3.2rem',
  borderRadius: '50%',
  border: `0.15rem solid ${
    ownerState.completed
      ? stepperColors.border.completed
      : ownerState.active
        ? stepperColors.border.active
        : stepperColors.border.inactive
  }`,
  backgroundColor: ownerState.completed
    ? stepperColors.background.completed
    : stepperColors.background.inactive,
  color: ownerState.completed ? stepperColors.icon.completed : stepperColors.icon.inactive,
  fontWeight: 500,
  fontSize: '1.4rem',
  transition: 'all 0.2s ease-in-out',
  flexShrink: 0,
  '& .step-icon-check': {
    fontSize: '1.4rem',
    fontWeight: 700,
    color: stepperColors.icon.completed,
  },
  '& .step-icon-custom, & .step-icon-active, & .step-icon-completed': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '1.6rem',
      height: '1.6rem',
    },
  },
}));

export const StyledStepLabel = styled(StepLabel)({
  flexDirection: 'row',
  alignItems: 'center',
  '& .MuiStepLabel-iconContainer': {
    paddingRight: '1.2rem',
  },
  '& .MuiStepLabel-labelContainer': {
    textAlign: 'left',
  },
  '& .MuiStepLabel-label': {
    marginTop: 0,
    color: stepperColors.text.inactive,
    '&.Mui-active': {
      color: stepperColors.text.active,
    },
    '&.Mui-completed': {
      color: stepperColors.text.completed,
    },
  },
  '& .step-label-content': {
    display: 'flex',
    flexDirection: 'column',
  },
  '& .step-number': {
    fontSize: '1.6rem',
    fontWeight: 400,
    color: stepperColors.text.inactive,
    lineHeight: 'normal',
    '&.active': {
      color: stepperColors.text.active,
    },
    '&.completed': {
      color: stepperColors.text.completed,
    },
  },
  '& .step-title': {
    fontSize: '1.6rem',
    fontWeight: 400,
    color: stepperColors.text.inactive,
    lineHeight: 'normal',

    '&.active': {
      color: stepperColors.text.active,
    },
    '&.completed': {
      color: stepperColors.text.completed,
    },
  },
  transition: 'all 0.3s ease-in-out',
});

export const StyledStep = styled(Step)({
  paddingRight: '1.6rem',
  paddingLeft: '1.1rem',
  transition: 'all 0.3s ease-in-out',
});
